const isNullOrEmpty = function(val) {
    if (val == null || val == "" || typeof(val) == undefined) {
        return true;
    } else {
        return false;
    }
}
const tofi = (val)=>{
	return val.toFixed(2);
}
const timeFormat = (value, format) => {
	if(!value) return '';
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
        h < 10 ? "0" + h : h
      }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
	}
	switch(format){
		case "yyyy-mm-dd":
			result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
		break;
		case "yyyy-mm":
			result = `${y}-${m < 10 ? "0" + m : m}`;
		break;
		case  "mm-dd":
			result = ` ${m < 10 ? "0" + m : m}:${d < 10 ? "0" + d : d}`;
		break;
		case "hh:mm":
		result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
		break;
		case "yyyy":
		result = `${y}`;
		break;
		case 'd':
			result = `${d < 10 ? "0" + d : d}`
		break;
		case 'y':
		result = `${y}`
		break;
		case 'm':
			result = `${m < 10 ? "0" + m : m}`
		break;
		case '年月日':
			result = `${y}年${m < 10 ? "0" + m : m}月${d < 10 ? "0" + d : d}日`;
		break;
	}

    return result;
};
function formatDate(date) {
	var date = new Date(date*1000);
	var YY = date.getFullYear() + '-';
	var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	return YY + MM + DD +" "+hh + mm + ss;
}
const isVip  = (data)=>{
	return data==1?'VIP用户':'普通用户';
}
const oredrS = (data)=>{
	/*
订单状态
1: 待付款
2: 待发货
3: 部分发货
4: 待收货
5: 已完成
6: 已取消
*/
	let state = '';
	switch(data){
		case 1:
			state = "待付款"
		break;
		case 2:
			state = "待发货"
		break;
		case 3:
			state = "部分发货"
		break;
		case 4:
			state = "待收货"
		break;
		case 5:
			state = "已完成"
		break;
		case 6:
			state = "已取消"
		break;
		case 7:
			state = "退款中"
		break;
		case 8:
			state = "已退款"
		break;
		case 9:
			state = "已关闭"
		break;
		case 10:
			state = "已评价"
		break;
	}
	return state;
}
const invo = (val)=>{
	let value = val;
	switch(val){
		case 0:
			value= '待开票';
		break;
		case 1:
			value= '已开票';
		break;
		case 2:
			value= '已取消';
		break;
	}
	return value;
}
// 1审核中； 2待发货； 3待收货； 4已完成； 5已取消； 6已驳回；
const integralS = (val)=>{
	let str = val;
	switch (val) {
		case 1:
			str = '审核中'
		break;
		case 2:
			str = '已接受'
		break;
		case 3:
			str = '已发货'
		break;
		case 4:
			str = '已完成'
		break;
		case 5:
			str = '已取消'
		break;
		case 6:
			str = '已驳回'
		break;
		default:
		break;
	}
	return str;
}
const toInt = (val)=>{
	if(val)
		return parseInt(val);
	else
		return 0;
}
export {
    isNullOrEmpty,		//是否为空
	timeFormat,			//时间截取
	formatDate,			//时间戳转换
	isVip,				//是不是vip用户
	oredrS,				//订单状态
	invo,				//发票状态
	integralS,			//积分订单状态
	tofi,				//保留两位小数
	toInt,				//取整数
}